import { Col, Row, Spin } from "antd";
import React from "react";
import { fetchQRCode } from "../../services/fetch-events";

const YoutubeClip = () => {
  const [loading, setLoading] = React.useState(true);
  const [youtubeClip, setYoutubeClip] = React.useState(null);

  React.useEffect(() => {
    const loadEvents = async () => {
      try {
        const result = await fetchQRCode();
        setYoutubeClip(Array.isArray(result.youtube) ? result.youtube : []);
      } catch (error) {
        console.error("Failed to fetch YouTube links:", error);
      } finally {
        setLoading(false);
      }
    };

    loadEvents();
  }, []);

  if (loading) return <Spin />;

  return (
    <Row gutter={[16, 16]}>
      {youtubeClip.map((src, index) => (
        <Col key={index} xs={24} sm={12} md={12} lg={8} xl={8} xxl={8}>
          <div
            style={{
              position: "relative",
              paddingBottom: "56.25%", // 16:9 aspect ratio
              height: 0,
              overflow: "hidden",
              borderRadius: 8,
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            }}
          >
            <iframe
              src={src}
              title={`YouTube video ${index + 1}`}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                border: "none",
              }}
            ></iframe>
          </div>
        </Col>
      ))}
    </Row>
  );
};

export default YoutubeClip;
